var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "special_radio" },
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("日程回答（工事）")]),
      _c(
        "vab-collapse-info",
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.getFieldValue("demandBaseIdModel.title", _vm.info)) +
                "［" +
                _vm._s(
                  _vm.getFieldValue(
                    "requestIdModel.purchaseOrderBaseIdModel.acceptOrderKey",
                    _vm.info
                  )
                ) +
                "］ "
            ),
          ]),
          _vm.showDownLoad
            ? _c("template", { slot: "upload" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex_center_align",
                    on: {
                      click: function ($event) {
                        return _vm.downLoadInfomation(
                          "/api/scheduleAdjAnswer/partner/estimate/download"
                        )
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v("見積情報ダウンロード")]),
                    _c("svg-icon", {
                      staticClass: "upload_svg",
                      attrs: { "icon-class": "download_2_line" },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "template",
            { slot: "row" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("建物")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "buildingCdModel.blgsnmkj",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.purchaseOrderBaseIdModel.itemCdModel.itmcdModel.itmnm",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品明細")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.purchaseOrderBaseIdModel.itemCdModel.itmdtlnm",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("発注件名")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box noborderright",
                      attrs: { span: 20 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "requestIdModel.purchaseOrderBaseIdModel.purchaseOrderName",
                                    _vm.info
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "sub_title" }, [
                            _vm._v(
                              " (発注No：" +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "requestIdModel.purchaseOrderBaseIdModel.acceptOrderNo",
                                    _vm.info
                                  )
                                ) +
                                "） "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("案件分類")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "demandBaseIdModel.businessForm",
                                _vm.info
                              ),
                              _vm.$divisions.consignmentWorkClassEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("依頼区分")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box noborderright flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "requestIdModel.requestClass",
                                _vm.info
                              ),
                              _vm.$divisions.requestClassEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("進行部門")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.requestDepCdModel.orgkjrn",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box rline", attrs: { span: 4 } },
                    [_vm._v("進行担当者")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box noborderright center_box",
                      attrs: { span: 8 },
                    },
                    _vm._l(
                      _vm.getFieldValue(
                        "requestIdModel.purchaseOrderBaseIdModel.purchaseOrderChargePersonModelList",
                        _vm.info
                      ),
                      function (item, index) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "empnmkj",
                                  item.chargePersonCdModel
                                )
                              ) +
                              " "
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("日程調整状況")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.info.adjScheduleStatus,
                              _vm.$divisions.adjScheduleStatusEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("書類提出期限")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box noborderright flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.docLimitDate",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("排水制限")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "requestIdModel.purchaseOrderBaseIdModel.drainageLimit",
                                _vm.info
                              ),
                              _vm.$divisions.drainageLimitEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box rline", attrs: { span: 4 } },
                    [_vm._v("産廃処理区分")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box noborderright flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "requestIdModel.purchaseOrderBaseIdModel.trashTreatDivision",
                                _vm.info
                              ),
                              _vm.$divisions.trashTreatDivisionEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("納品予定年月")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box noborderright flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFomateMonth(
                              _vm.getFieldValue(
                                "demandBaseIdModel.contractEndDate",
                                _vm.info
                              )
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("発注コメント")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.purchaseOrderBaseIdModel.purchaseOrderComment",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "info_main workInfo new_workInfo" },
        [
          _c(
            "div",
            { staticClass: "head_box flex_start flex_center_align" },
            [
              _c("svg-icon", { attrs: { "icon-class": "edit_2_line" } }),
              _c("span", { staticClass: "hd_title" }, [_vm._v("日程調整")]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "h_date flex_center_align" },
            [
              _c("svg-icon", {
                staticClass: "h_svg",
                attrs: { "icon-class": "tryangle_down" },
              }),
              _c("span", { staticClass: "h_title h_img_none" }, [
                _vm._v(" 対応日程と詳細情報を登録してください "),
              ]),
              _c("span", { staticClass: "h_title h_img_none h_txt_red" }, [
                _vm._v(
                  " ※ 工期設定が月末になりますと完了の検収に時間を要する場合がございます。ゆとりのある工期設定をお願いします。 "
                ),
              ]),
            ],
            1
          ),
          _c(
            "vab-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _c(
                "div",
                { staticClass: "sure_box top_info mtn" },
                [
                  _vm._l(
                    _vm.form.scheduleAdjDetailModelList,
                    function (row, index) {
                      return _c(
                        "vab-row",
                        { key: index, staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [
                              _c("div", { staticClass: "flex_colum" }, [
                                _c("div", [
                                  _vm._v("対応日程" + _vm._s(index + 1)),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "clear_btn",
                                    class:
                                      _vm.form.scheduleAdjDetailModelList
                                        .length == 1 || _vm.dealingDisable
                                        ? "disabledBtn "
                                        : "",
                                    on: {
                                      click: function ($event) {
                                        return _vm.delSchedule(index, row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 削除 ")]
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box nopadding pdtb8",
                              attrs: { span: 20 },
                            },
                            [
                              _c(
                                "vab-row",
                                { staticClass: "flex_center_align margin_8" },
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "flex_center_align picker_label",
                                    },
                                    [
                                      _c("span", { staticClass: "tz_title" }, [
                                        _vm._v("日程"),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "vab-col",
                                    { staticClass: "date_picker width_auto" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex_start tz_right flex_center_align",
                                        },
                                        [
                                          _c("vab-date-picker", {
                                            attrs: {
                                              type: "date",
                                              "label-show": false,
                                              "value-format": "yyyy/MM/dd",
                                              "label-error": "日程",
                                              format: "yyyy/MM/dd",
                                              validate: _vm.vaildateTimeStart(
                                                row,
                                                index
                                              ),
                                              prop:
                                                "scheduleAdjDetailModelList." +
                                                index +
                                                ".startDateTime",
                                              "end-date-prop":
                                                "scheduleAdjDetailModelList." +
                                                index +
                                                ".endDateTime",
                                              clearable: false,
                                              disabled: _vm.dealingDisable,
                                            },
                                            on: {
                                              change: function (value) {
                                                return _vm.changeWattingDate(
                                                  row,
                                                  index,
                                                  value
                                                )
                                              },
                                            },
                                          }),
                                          _c("div", { staticClass: "line" }, [
                                            _vm._v("～"),
                                          ]),
                                          _c("vab-date-picker", {
                                            attrs: {
                                              type: "date",
                                              "label-show": false,
                                              "value-format": "yyyy/MM/dd",
                                              "label-error": "日程",
                                              format: "yyyy/MM/dd",
                                              validate: _vm.vaildateTimeEnd(
                                                row,
                                                index
                                              ),
                                              prop:
                                                "scheduleAdjDetailModelList." +
                                                index +
                                                ".endDateTime",
                                              clearable: false,
                                              disabled: _vm.dealingDisable,
                                              "start-date-prop":
                                                "scheduleAdjDetailModelList." +
                                                index +
                                                ".startDateTime",
                                            },
                                            on: {
                                              change: function (value) {
                                                return _vm.changeWattingDate(
                                                  row,
                                                  index,
                                                  value
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                { staticClass: "margin_8" },
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "flex_center_align picker_label",
                                    },
                                    [
                                      _c("span", { staticClass: "tz_title" }, [
                                        _vm._v("時間"),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "vab-col",
                                    { staticClass: "time_picker" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex_start flex_center_align",
                                        },
                                        [
                                          _c("vab-time-picker", {
                                            attrs: {
                                              prop:
                                                "scheduleAdjDetailModelList." +
                                                index +
                                                ".startTime",
                                              format: "HH:mm",
                                              "value-format": "HH:mm",
                                              "value-format-sss": true,
                                              disabled: row.disabled,
                                              "end-date-prop":
                                                "scheduleAdjDetailModelList." +
                                                index +
                                                ".endTime",
                                            },
                                          }),
                                          _c("div", { staticClass: "line" }, [
                                            _vm._v("～"),
                                          ]),
                                          _c("vab-time-picker", {
                                            attrs: {
                                              prop:
                                                "scheduleAdjDetailModelList." +
                                                index +
                                                ".endTime",
                                              format: "HH:mm",
                                              "value-format": "HH:mm",
                                              "value-format-sss": true,
                                              disabled: row.disabled,
                                              "start-date-prop":
                                                "scheduleAdjDetailModelList." +
                                                index +
                                                ".startTime",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "end_box" },
                                            [
                                              _c("vab-checkbox", {
                                                ref: "dayFlag" + index,
                                                refInFor: true,
                                                class: row.checkDisabled
                                                  ? "checkbox_disabled"
                                                  : "",
                                                attrs: {
                                                  label: "終日",
                                                  prop:
                                                    "scheduleAdjDetailModelList." +
                                                    index +
                                                    ".dayFlag",
                                                  "code-enum":
                                                    _vm.$divisions.validFlgEnum,
                                                  disabled: row.checkDisabled,
                                                },
                                                on: {
                                                  change: function (value) {
                                                    return _vm.changeDayFlag(
                                                      value,
                                                      row
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "line_boder margin_8" }),
                              _vm._l(_vm.hbList, function (item, s) {
                                return _c(
                                  "vab-row",
                                  {
                                    key: s,
                                    staticClass: "margin_8 width_auto",
                                  },
                                  [
                                    _c(
                                      "vab-col",
                                      {
                                        staticClass:
                                          "flex_center_align picker_label",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "tz_title" },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "vab-col",
                                      { staticClass: "width_auto" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex_start flex_center_align width_auto",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "radio_box" },
                                              [
                                                _c("vab-radio-group", {
                                                  ref: item.prefix + index,
                                                  refInFor: true,
                                                  staticClass: "margin_0",
                                                  attrs: {
                                                    prop:
                                                      "scheduleAdjDetailModelList." +
                                                      index +
                                                      "." +
                                                      item.prefix +
                                                      "ExistFlag",
                                                    "code-enum":
                                                      _vm.$divisions
                                                        .existFlag2Enum,
                                                    filter: "existFlag2",
                                                    disabled:
                                                      _vm.dealingDisable,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex_start flex_center_align time_picker_no",
                                              },
                                              [
                                                _c("vab-time-picker", {
                                                  staticClass:
                                                    "margin_0 work_time",
                                                  attrs: {
                                                    prop:
                                                      "scheduleAdjDetailModelList." +
                                                      index +
                                                      "." +
                                                      item.prefix +
                                                      "StartTime",
                                                    format: "HH:mm",
                                                    "value-format": "HH:mm",
                                                    "value-format-sss": true,
                                                    validate:
                                                      _vm.validateStartTime(
                                                        row,
                                                        item,
                                                        index
                                                      ),
                                                    "end-date-prop":
                                                      "scheduleAdjDetailModelList." +
                                                      index +
                                                      "." +
                                                      item.prefix +
                                                      "EndTime",
                                                    disabled:
                                                      !_vm.checkEnumFlag(
                                                        row[
                                                          item.prefix +
                                                            "ExistFlag"
                                                        ]
                                                      ) || _vm.dealingDisable,
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "line" },
                                                  [_vm._v("～")]
                                                ),
                                                _c("vab-time-picker", {
                                                  staticClass: "margin_0",
                                                  attrs: {
                                                    prop:
                                                      "scheduleAdjDetailModelList." +
                                                      index +
                                                      "." +
                                                      item.prefix +
                                                      "EndTime",
                                                    format: "HH:mm",
                                                    "value-format": "HH:mm",
                                                    "value-format-sss": true,
                                                    validate:
                                                      _vm.validateEndTime(
                                                        row,
                                                        item,
                                                        index
                                                      ),
                                                    "start-date-prop":
                                                      "scheduleAdjDetailModelList." +
                                                      index +
                                                      "." +
                                                      item.prefix +
                                                      "StartTime",
                                                    disabled:
                                                      !_vm.checkEnumFlag(
                                                        row[
                                                          item.prefix +
                                                            "ExistFlag"
                                                        ]
                                                      ) || _vm.dealingDisable,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "flex_center_align picker_label hei32",
                                    },
                                    [
                                      _c("span", { staticClass: "tz_title" }, [
                                        _vm._v("駐車利用"),
                                      ]),
                                    ]
                                  ),
                                  _c("vab-col", { staticClass: "width_auto" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex_start flex_center_align width_auto hei32",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "radio_box" },
                                          [
                                            _c("vab-radio-group", {
                                              ref: "parkFlg" + index,
                                              refInFor: true,
                                              staticClass: "margin_0",
                                              attrs: {
                                                prop:
                                                  "scheduleAdjDetailModelList." +
                                                  index +
                                                  ".parkFlg",
                                                "code-enum":
                                                  _vm.$divisions
                                                    .necessaryFlagEnum,
                                                filter: "existFlag2",
                                                disabled: _vm.dealingDisable,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  !_vm.dealingDisable
                    ? _c("vab-row", { staticClass: "add_btn_box" }, [
                        _c("div", { staticClass: "tzx_box" }, [
                          _c(
                            "span",
                            {
                              staticClass: "upload_btn_box",
                              on: { click: _vm.addSchedule },
                            },
                            [_vm._v(" 対応日程追加 ")]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c(
                    "vab-collapse",
                    {
                      staticClass: "message_collapse",
                      attrs: { title: "カレンダーを閉じる", dot: true },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "los_box" },
                        [_c("vab-calendar", { ref: "calendar" })],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "tableInfo changeInfo" },
                    [
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("調整内容確認先")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass:
                                "word_box nopadding2 flex_center_align",
                              attrs: { span: 20 },
                            },
                            [
                              _c("vab-checkbox", {
                                attrs: {
                                  prop: "localManagerAdjFlg",
                                  "code-enum": _vm.$divisions.localAdjFlgEnum,
                                  label: "現地管理員",
                                  disabled: _vm.dealingDisable,
                                },
                              }),
                              _c("div", { staticStyle: { width: "16px" } }),
                              _c("vab-checkbox", {
                                staticClass: "mr16",
                                attrs: {
                                  prop: "basePersonAdjFlg",
                                  "code-enum": _vm.$divisions.localAdjFlgEnum,
                                  label: "建物担当者",
                                  disabled: _vm.dealingDisable,
                                },
                              }),
                              _c("div", { staticStyle: { width: "16px" } }),
                              _c("vab-checkbox", {
                                staticClass: "mr16",
                                attrs: {
                                  prop: "customerAdjFlg",
                                  "code-enum": _vm.$divisions.localAdjFlgEnum,
                                  label: "工事担当者",
                                  disabled: _vm.dealingDisable,
                                },
                              }),
                              _c("div", { staticStyle: { width: "16px" } }),
                              _c("vab-checkbox", {
                                attrs: {
                                  prop: "otherCheckbox",
                                  "code-enum": _vm.$divisions.localAdjFlgEnum,
                                  label: "その他",
                                  checked: true,
                                  disabled: _vm.dealingDisable,
                                },
                                on: { change: _vm.otherCheckboxChange },
                              }),
                              _c("div", { staticStyle: { width: "16px" } }),
                              _c("vab-input", {
                                attrs: {
                                  prop: "otherAdjTxt",
                                  maxlength: "255",
                                  disabled: _vm.otherDisabled,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("広報")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box nopadding2 pdtb8",
                              attrs: { span: 20 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_colum" },
                                [
                                  _c("vab-radio-group", {
                                    staticClass: "mr16 in_mb20",
                                    attrs: {
                                      prop: "noticeFlg",
                                      "code-enum":
                                        _vm.$divisions.existFlag2Enum,
                                      filter: "existFlag2",
                                      disabled: _vm.dealingDisable,
                                    },
                                    on: { change: _vm.changeNoticeFlg },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "flex_start" },
                                    [
                                      _c("vab-checkbox", {
                                        attrs: {
                                          prop: "localPostingFlg",
                                          "code-enum":
                                            _vm.$divisions.necessaryFlagEnum,
                                          label: "掲示（現地に提示）",
                                          disabled:
                                            _vm.dealingDisable ||
                                            _vm.isEqualCodeEnum(
                                              _vm.form.noticeFlg,
                                              _vm.$divisions.existFlag2Enum
                                                .enum_blank
                                            ),
                                        },
                                      }),
                                      _c("div", {
                                        staticStyle: { width: "16px" },
                                      }),
                                      _c("vab-checkbox", {
                                        attrs: {
                                          prop: "managePostingFlg",
                                          "code-enum":
                                            _vm.$divisions.necessaryFlagEnum,
                                          label: "掲示（管理室へFax）",
                                          disabled:
                                            _vm.dealingDisable ||
                                            _vm.isEqualCodeEnum(
                                              _vm.form.noticeFlg,
                                              _vm.$divisions.existFlag2Enum
                                                .enum_blank
                                            ),
                                        },
                                      }),
                                      _c("div", {
                                        staticStyle: { width: "16px" },
                                      }),
                                      _c("vab-checkbox", {
                                        staticClass: "mr16",
                                        attrs: {
                                          prop: "postingFlag",
                                          "code-enum":
                                            _vm.$divisions.necessaryFlagEnum,
                                          label: "ポスティング",
                                          disabled:
                                            _vm.dealingDisable ||
                                            _vm.isEqualCodeEnum(
                                              _vm.form.noticeFlg,
                                              _vm.$divisions.existFlag2Enum
                                                .enum_blank
                                            ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("消防検査")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass:
                                "word_box nopadding2 flex_center_align",
                              attrs: { span: 20 },
                            },
                            [
                              _c("vab-radio-group", {
                                attrs: {
                                  prop: "fireInspectionFlg",
                                  "code-enum": _vm.$divisions.existFlag2Enum,
                                  filter: "existFlag2",
                                  disabled: _vm.dealingDisable,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("消防署事前協議")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass:
                                "word_box nopadding2 flex_center_align",
                              attrs: { span: 20 },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { cclass: "flex_colum" } },
                                [
                                  _c("vab-radio-group", {
                                    attrs: {
                                      prop: "fireConsultationFlg",
                                      "code-enum":
                                        _vm.$divisions.fireConsultationFlgEnum,
                                      filter: "fireConsultationFlg",
                                      disabled: _vm.dealingDisable,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("産廃処理担当者")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass:
                                "word_box nopadding2 flex_center_align",
                              attrs: { span: 20 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "tz_right w140" },
                                [
                                  _c("vab-input", {
                                    attrs: {
                                      prop: "constructionPersonName",
                                      disabled: _vm.dealingDisable,
                                      maxlength: "42",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v(" 産廃処理担当者 電話番号 ")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass:
                                "word_box nopadding2 flex_center_align",
                              attrs: { span: 20 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "tz_right w140" },
                                [
                                  _c("vab-input", {
                                    directives: [
                                      {
                                        name: "input",
                                        rawName: "v-input.num",
                                        modifiers: { num: true },
                                      },
                                    ],
                                    attrs: {
                                      prop: "telNo",
                                      disabled: _vm.dealingDisable,
                                      maxlength: "18",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("産廃予想排出量")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass:
                                "word_box nopadding2 flex_center_align",
                              attrs: { span: 20 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "tz_right w140" },
                                [
                                  _c("vab-input", {
                                    directives: [
                                      {
                                        name: "input",
                                        rawName: "v-input.float",
                                        value: 3,
                                        expression: "3",
                                        modifiers: { float: true },
                                      },
                                      {
                                        name: "numberFormat",
                                        rawName: "v-numberFormat.float",
                                        value: 3,
                                        expression: "3",
                                        modifiers: { float: true },
                                      },
                                    ],
                                    staticClass: "percentInput",
                                    attrs: {
                                      prop: "industryWasteAmount",
                                      disabled: _vm.dealingDisable,
                                      validate: "range:0|9999999.999",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [_vm._v("立米")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "sure_box top_info" },
                [
                  _c(
                    "vab-row",
                    { staticClass: "row_box" },
                    [
                      _c(
                        "vab-col",
                        { staticClass: "title_box", attrs: { span: 4 } },
                        [_vm._v("協力会社コメント")]
                      ),
                      _c(
                        "vab-col",
                        {
                          staticClass: "word_box nopadding2 pdtb8",
                          attrs: { span: 20 },
                        },
                        [
                          _c("vab-textarea", {
                            attrs: {
                              type: "textarea",
                              prop: "submitRemarks",
                              rows: "5",
                              maxlength: "1170",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("vab-message", {
                    staticClass: "detail_nopadding",
                    attrs: {
                      "msg-type":
                        _vm.$divisions.adjSourceClassEnum.enum_1.value,
                      title: "コメント履歴を閉じる",
                      "msg-id": _vm.$route.query.requestDetailId,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "flex_end mg12" },
            [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }